import styled, { css } from 'styled-components';

// Types
import { buttonProps } from './types';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xl};
  width: 100%;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spacing.l};
  }
`;

export const ContainerTabsButtons = styled.div`
  display: flex;
`;

export const Ul = styled.ul`
  display: flex;
  border: 0.1rem solid ${({ theme }) => theme.colors.greyVeryDark};
  border-radius: 0.8rem;
`;

export const Li = styled.li`
  /* Las 18rem de abajo son la medida PREFERIDA de una pestaña, no un suelo: van
     como base del flex para que, cuando la fila no da de sí, las pestañas se
     encojan hasta su propio texto en vez de desbordar. Cuando hay sitio de
     sobra siguen repartiéndose por igual, como antes. */
  flex: 1 1 18rem;
  display: ${({ hidden }) => (hidden ? 'none' : 'block')};
`;

export const Button = styled.button<buttonProps>`
  width: 100%;
  padding: 0.7rem ${({ theme }) => theme.spacing.m};
  border-radius: 0.8rem;
  white-space: nowrap;
  border: none;
  appearance: none;
  background: none;
  cursor: pointer;

  ${({ isActive }) =>
    isActive &&
    css`
      outline: 0.2rem solid ${({ theme }) => theme.colors.garnet};
      outline-offset: -0.1rem;
    `}
  /* 🔴 Aquí había un "min-width: 18rem" en tablet. Como el <ul> ni envuelve ni
     recorta, ese suelo era INALCANZABLE y la fila se salía: con 5 pestañas
     pedía 900 px dentro de un hueco de 836 (medido a 900 px de ancho) y la
     última, "Multimedia", quedaba cortada junto con su marco de seleccionada;
     en vertical pasaba igual en la fila de 3 (549 px en 536). La medida
     preferida vive ahora en la base del flex del <li>, que sí cede. */
`;

export const ContainerSections = styled.div``;

export const Section = styled.section``;

export const ContainerUl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.7rem;
  /* Fix tablet vertical (2026-07-29): sin esto el contenedor se dimensiona al
     CONTENIDO (ancho de la fila más larga) en vez de al 100%, así que la fila
     de abajo no llegaba al borde derecho y los tabs no rellenaban (huecos).
     Con width:100% ambas filas ocupan todo el ancho y los tabs (flex:1) se
     reparten al 50%/50% (o 100% si van solos). Solo se usa cuando la barra se
     parte en dos filas (≤1023 px). */
  width: 100%;
`;
